import { TrialBalanceModel } from '../tb/trial-balance.model';
import { IntegrationSourceInterface } from './integration-source.interface';

export class EngagementInterface {
  public integrationSource: IntegrationSourceInterface = null;
  public tbData: TrialBalanceModel[];
}
